import { createIcon } from '../icons/utils';

/**
 * Legacy ProgressBars' in-clinic glyph: an outlined monitor inside a ring.
 *
 * Legacy replaced a transmission's whole status glyph with this one whenever the
 * session type was InClinic, and drew it in a single neutral grey regardless of the
 * transmission's priority colour — so this icon ignores the caller's colour classes.
 *
 * Distinct from `InclinicTransmissionIcon` (assets/icons/transmission), which is the
 * smaller badge glyph used elsewhere in the app.
 */
export const InClinicCircleIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g
        stroke="hsl(var(--themed-gray-700))"
        strokeWidth={1.00732}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9.83355 19.3323H15.1664C17.8462 19.3323 18.3262 18.259 18.4662 16.9525L18.9661 11.6196C19.1461 9.99306 18.6795 8.6665 15.8331 8.6665H9.16694C6.32051 8.6665 5.85388 9.99306 6.03387 11.6196L6.53382 16.9525C6.67381 18.259 7.15377 19.3323 9.83355 19.3323Z" />
        <path d="M9.8335 8.66645V8.13316C9.8335 6.95325 9.8335 6 11.9667 6H13.0332C15.1664 6 15.1664 6.95325 15.1664 8.13316V8.66645" />
        <path d="M13.8334 13.3326V13.9992C13.8334 14.0059 13.8334 14.0059 13.8334 14.0126C13.8334 14.7392 13.8268 15.3325 12.5002 15.3325C11.1803 15.3325 11.167 14.7458 11.167 14.0192V13.3326C11.167 12.666 11.167 12.666 11.8336 12.666H13.1668C13.8334 12.666 13.8334 12.666 13.8334 13.3326Z" />
        <path d="M18.9331 11.9995C17.3932 13.1194 15.6333 13.786 13.8335 14.0127" />
        <path d="M6.24707 12.1797C7.74695 13.2063 9.44014 13.8262 11.1667 14.0195" />
      </g>
      <path
        d="M24.25 12.5C24.25 18.9858 18.9858 24.25 12.5 24.25C6.01421 24.25 0.75 18.9858 0.75 12.5C0.75 6.01421 6.01421 0.75 12.5 0.75C18.9858 0.75 24.25 6.01421 24.25 12.5Z"
        stroke="hsl(var(--themed-gray-700))"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'InClinicCircleIcon', defaultSize: 25, classNameBase: '' },
);
